import decode from 'jwt-decode';
import queryString from 'qs';
import {
    REFERRAL_ID_SESSIONSTORAGE_KEY,
    AUTHENTICATION_DATA_LOCALSTORAGE_KEY
} from '../constants/constants';
import sessionStorage from '../utils/sessionStorage';
import localStorage from '../utils/localStorage';
require('whatwg-fetch');

export default class AuthenticationService {
    isAuthenticated = (cookies) => {
        if (this._getAuthenticationData(cookies) === null) {
            return false;
        }

        const token = this.getAccessToken(cookies);
        const refreshToken = this.getRefreshToken(cookies);
        if (!token || !refreshToken) {
            return false;
        }

        try {
            const {exp} = decode(refreshToken);
            if (exp * 1000 < new Date().getTime()) {
                return false;
            }

        } catch (e) {
            return false;
        }

        return true;
    };

    authenticateFb = async (facebookToken, cookies) => {
        const authUrl = this._createAuthUrl(facebookToken);
        const token = this.getAccessToken();
        let res;
        if (!token) {
            res = await fetch(authUrl);
        } else {
            res = await fetch(authUrl, {headers: {authorization: `Bearer ${token}`}});
        }

        const data = await res.json();
        if (res.status < 200 || res.status >= 400 || !data.partnerToken) {
            throw res;
        } else {
            this._setAuthenticationData({
                accessToken: data.accessToken,
                refreshToken: data.refreshToken,
                ...(data.partnerToken && {accessPartner: data.partnerToken})
            }, cookies);

            this._removeReferralId();

            return data;
        }
    };

    authenticateFormLogin = async (formSend, cookies) => {
        const {authUrl, formBody} = this._createAuthUrlForm(formSend);

        const res = await fetch(authUrl
            ,
            {
                method: 'POST',
                body: formBody,
                headers: {
                    'Accept': 'application/json; charset=utf-8',
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

        const data = await res.json();
        if (res.status < 200 || res.status >= 400 || res.status === 402 || !data.partnerToken) {
            throw res;
        }
        else {
            this._setAuthenticationData({
                accessToken: data.accessToken,
                refreshToken: data.refreshToken,
                ...(data.partnerToken && {accessPartner: data.partnerToken})
            }, cookies);

            this._removeReferralId();
            return data;
        }
    };

    logout = (cookies) => {
        this._deleteAuthenticationData(cookies);
    };

    getAccessPartner(cookies) {
        if (!this._getAuthenticationDataPartner(cookies)) {
            return null;
        }
        return this._getAuthenticationDataPartner(cookies);
    }

    getAccessToken(cookies) {
        if (!this._getAuthenticationData(cookies)) {
            return null;
        }

        return this._getAuthenticationData(cookies).accessToken;
    }

    getRefreshToken(cookies) {
        if (!this._getAuthenticationData(cookies)) {
            return null;
        }

        return this._getAuthenticationData(cookies).refreshToken;
    }

    async refreshAccessToken(cookies) {
        const refreshToken = this.getRefreshToken();
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh/token`, {
            headers: {
                'Authorization': `Refresh ${refreshToken}`
            }
        });
        const data = await res.json();

        if (res.status >= 400) {
            throw new Error(data.message);
        }

        this._setAuthenticationData({
            accessToken: data.accessToken,
            refreshToken: data.refreshToken
        }, cookies);
    }

    _createAuthUrl(facebookToken) {
        const authUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth/facebook/token?access_token=${facebookToken}`;

        const referralId = sessionStorage.getItem(REFERRAL_ID_SESSIONSTORAGE_KEY);

        const queryParams = {
            ref: referralId ? referralId : undefined,
        };

        const query = queryString.stringify(queryParams);
        return query ? authUrl.concat(`&${query}`) : authUrl;
    }

    _createAuthUrlForm(formSend) {
        let authUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth/local/token`;

        let formBody = [];
        for (const property in formSend) {
            const encodedKey = encodeURIComponent(property);
            const encodedValue = encodeURIComponent(formSend[property]);
            formBody.push(encodedKey + '=' + encodedValue);
        }
        formBody = formBody.join('&');
        const referralId = sessionStorage.getItem(REFERRAL_ID_SESSIONSTORAGE_KEY);

        const queryParams = {
            ref: referralId ? referralId : undefined,
        };

        const query = queryString.stringify(queryParams);
        query.concat('&');
        authUrl = query ? authUrl.concat(`?${query}`) : authUrl;
        return {authUrl, formBody};
    }

    _removeReferralId() {
        sessionStorage.removeItem(REFERRAL_ID_SESSIONSTORAGE_KEY);
    }

    _deleteAuthenticationData = (cookies) => {
        localStorage.removeItem(AUTHENTICATION_DATA_LOCALSTORAGE_KEY);
        cookies.remove(AUTHENTICATION_DATA_LOCALSTORAGE_KEY, {
            domain: process.env.REACT_APP_SSO_COOKIE_DOMAIN,
            path: '/',
            sameSite: 'None',
            secure: true,
            maxAge: 86400
        });
    };

    _setAuthenticationData = (data, cookies) => {
        //localStorage.setItem(AUTHENTICATION_DATA_LOCALSTORAGE_KEY, JSON.stringify(data));
        cookies.set(AUTHENTICATION_DATA_LOCALSTORAGE_KEY, JSON.stringify(data), {
            domain: process.env.REACT_APP_SSO_COOKIE_DOMAIN,
            path: '/',
            sameSite: 'None',
            secure: true,
            maxAge: 86400
        });
    };

    _getAuthenticationDataPartner = (cookies) => {
        try {
            return cookies.get(AUTHENTICATION_DATA_LOCALSTORAGE_KEY).accessPartner;
        }catch (e) {
            return null;
        }
    };

    _getAuthenticationData = (cookies) => {
        try {
            return cookies.get(AUTHENTICATION_DATA_LOCALSTORAGE_KEY);
        }catch (e) {
            return null;
        }
    };
}
